import * as React from 'react';
import { EntityCombobox, type EntityLookupItem } from '../ui/EntityCombobox';
import { fetcher } from '../../lib/api-fetcher';

export interface SubscriberPickerProps {
  value?: string;
  onChange: (value: string, item?: EntityLookupItem) => void;
  groupId?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function SubscriberPicker({
  value,
  onChange,
  groupId,
  placeholder = 'Select Subscriber / Ticket...',
  disabled,
  className,
}: SubscriberPickerProps) {
  const fetchSubscribers = React.useCallback(
    async (query: string): Promise<EntityLookupItem[]> => {
      try {
        const url = groupId
          ? `/staff/v1/chit-groups/${groupId}/subscribers?limit=30${query ? `&q=${encodeURIComponent(query)}` : ''}`
          : `/staff/v1/subscribers?limit=30${query ? `&q=${encodeURIComponent(query)}` : ''}`;
        const res = await fetcher.get<{ data?: Array<{ id: string; ticketNumber?: string; customerName?: string; name?: string; mobile?: string; status?: string }> }>(url);
        const list = res?.data || [];
        return list.map((s) => ({
          id: s.id,
          code: s.ticketNumber ? `Ticket #${s.ticketNumber}` : 'SUBSCRIBER',
          title: s.customerName || s.name || 'Subscriber',
          subtitle: s.mobile ? `Mobile: ${s.mobile}` : undefined,
          badge: s.status,
        }));
        // allow-silent-catch: return empty list on search failure
      } catch {
        return [];
      }
    },
    [groupId]
  );

  return (
    <EntityCombobox
      value={value}
      onChange={onChange}
      fetchItems={fetchSubscribers}
      placeholder={placeholder}
      searchPlaceholder="Search subscriber by ticket # or name..."
      disabled={disabled}
      className={className}
    />
  );
}
